import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'normalize.css/normalize.css'
import moment from 'moment'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import {isAuth, isMulti} from '@/utils/common'
import { post, get} from '@/utils/request'
import cloneDeep from 'lodash/cloneDeep'
import * as echarts from 'echarts';
import ElTableEdit from '@/components/el-table-edit'


Vue.use(ElementUI)
Vue.use(ElTableEdit)
Vue.prototype.$moment = moment
Vue.prototype.$post = post;
Vue.prototype.$get = get;
Vue.prototype.isAuth = isAuth
Vue.prototype.isMulti = isMulti
Vue.prototype.$echarts = echarts


Vue.config.productionTip = false

window.CONF = {}
window.CONF['storeState'] = cloneDeep(store.state)
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
